module.exports = __webpack_public_path__ + "assets/manual_assuranceApartment-404a2070e7b92952617f9af16a6a1a21.pdf";